import { Attachment } from './attachment';
import { WithConnectStamp } from '../connect';

export interface DocumentLibrary extends Attachment, WithConnectStamp {
    _id: string;
    title: string;
    attachment: Attachment;
    createdDate?: Date;
    updateDate?: Date;
    system?: boolean;
    active?: boolean;
    mergeType?: DocumentMergeType;
    description?: string;
    mustache?: boolean;
    useNewReportingEngine?: boolean;
}


export enum DocumentMergeType {
    Job = 'Job',
    WorkOrder = 'WorkOrder',
    WorkOrderLabels = 'WorkOrderLabels',
    Form = 'Form',
    Invoice = 'Invoice',
    QuotePro = 'QuotePro',
    PurchaseOrder = 'PurchaseOrder',
    None = 'None'
}
